import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fc8c54ea")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex mb-3 items-center hidden sm:block text-3xl px-2" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "veMOND")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 invest-farm-separator hidden sm:block" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start items-center mb-2 sm:mb-8 mt-4 sm:mt-16 pl-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vemond-title" }, " Coming Soon ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ], 64))
}